import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input} from 'antd';
import {DollarOutlined ,UserOutlined,BookOutlined,UsergroupAddOutlined,PlusCircleOutlined } from '@ant-design/icons';
import MoneyOutlinedIcon from '@mui/icons-material/MoneyOutlined';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import TollOutlinedIcon from '@mui/icons-material/TollOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import axios from './apiClient';
import Alert from './alert';
import moment from 'moment/moment';
import { Tabs } from '@mui/material';

const {RangePicker} = DatePicker;

export default function Dashboard() {

  const [page,setPage] = useState(1);
  const [statements,setStatements] = useState([]);
  const [totalStatements, setTotalStatements] = useState();
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [trnxType, setTrnxType] = useState("all");
  const [date,setDate] = useState({startDate: "",endDate: ""})
  const [balance,setBalance] = useState('');
  const [totalMasters,setTotalMasters] = useState('');
  const [totalSubOwners,setTotalSubOwners] = useState('');
  const [slipsReport,setSlipsReport] = useState({})
  const [totalDepositAmount,setTotalDepositAmount] = useState(0);
  const [totalWithdrawAmount,setTotalWithdrawAmount] = useState(0);

  const didMount = useRef(false);

  const trnxTypeOptions = ['all', 'deposit', 'withdraw', 'refill']

  const navigate = useNavigate()


   useEffect(()=>{
    const today = moment();
    // const startDate = moment(today).subtract(30, 'days').format('YYYY-MM-DD');
    const startDate = moment(today).format('YYYY-MM-DD');
    const endDate = moment(today).format('YYYY-MM-DD');
    setDate({startDate: startDate,endDate: endDate})
   },[])

  async function fetchData() {
    setLoading(true)
     let data = await axios.get(`/report/getStatementByHolderId?type=${trnxType}&startDate=${date.startDate}&endDate=${date.endDate}&current=${page}&pageSize=10`);
     
    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setStatements([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setStatements(data.data.transactions)
    setTotalStatements(data.data.pagination.total)
    setLoading(false)
  }

  async function getBalance(){
    let res = await axios.get(`/report/ownerDashboard`);
     if(res.code == 200) {
       const {balance,totalMaster,totalSubOwner} = res.data;
       setBalance(balance);
       setTotalMasters(totalMaster);
       setTotalSubOwners(totalSubOwner);
     }
  }

  async function getSlipsReport(){
    let res = await axios.get(`/report/getReportSlipByComplete?startDate=${date.startDate}&endDate=${date.endDate}`);
     if(res.code == 200) {
      if(res.data[0]){
        setSlipsReport(res.data[0])
      }
     }
  }

  


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page)

  const handleTrnxTypeChange = (value) => setTrnxType(value);
  
  const handleDateChange = async (v,dateString) => setDate({startDate: dateString[0],endDate: dateString[1]});
  
  useEffect(()=> {
    getTotalDepositAndWithdraw();
    getSlipsReport();
    if(didMount.current){
      fetchData()
    }else{
      didMount.current = true;
      getBalance();
    }
  },[trnxType,date,page])

  async function getTotalDepositAndWithdraw(){
    let res = await axios.get(`/report/getTotalDepositAndWithdrawByDate?startDate=${date.startDate}&endDate=${date.endDate}`)
    if(res.code != 200) return;
    let {total_deposit_amount,total_withdraw_amount} = res.data;
    setTotalDepositAmount(total_deposit_amount);
    setTotalWithdrawAmount(total_withdraw_amount);
  }

  const columns = [
      // {
      //   title: 'Username',
      //   render: ()=> holderName
      // },
      {
        title: 'Trnx Type',
        dataIndex: 'trnxType',
        key: 'trnxType',
      },
      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
      },
      {
        title: 'Date',
        key: 'trnxDate',
        dataIndex: 'trnxDate',
        render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
      },
      {
        title: 'Reason',
        key: 'reason',
        dataIndex: 'reason',
      },
      {
        title: 'Amount',
        key: 'amount',
        dataIndex: 'amount',
      },
      {
        title: 'Opening Balance',
        key: 'openingBalance',
        dataIndex: 'openingBalance',
      },
      {
        title: 'Closing Balance',
        key: 'closingBalance',
        dataIndex: 'closingBalance',
      },
  ];

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div style={{display: 'flex', overflowX: "scroll",overflow: 'hidden'}}>
            <Tabs
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example"
            >
          <div  style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <PersonOutlineOutlinedIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "orange"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Masters</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{totalMasters}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <PeopleOutlineOutlinedIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "violet"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Sub Owners</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{totalSubOwners}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <DollarOutlined   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#77ba4f"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Bet</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(slipsReport?.total_bet_amount).toLocaleString()}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <PlusCircleOutlined  style={{fontSize: "2.5rem",marginRight: "1rem",color: "#5c6cc7"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Commission</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(slipsReport?.total_commission_amount).toLocaleString()}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <LocalAtmIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#5a5a5a"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Revenue</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(slipsReport?.total_revenue_amount).toLocaleString()}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <BookOutlined   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#a78008"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Slips</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(slipsReport?.total_slip).toLocaleString()}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <TollOutlinedIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#ec9178"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Pay Amount</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(slipsReport?.total_winned_amount).toLocaleString()}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <MoneyOutlinedIcon    style={{fontSize: "2.5rem",marginRight: "1rem",color: "#399bac"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Deposit Amount</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(totalDepositAmount).toLocaleString()}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <CurrencyExchangeOutlinedIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#cc4a3f"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Withdraw Amount</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(totalWithdrawAmount).toLocaleString()}</h4>
             </div>
          </div>
          <div></div>
        </Tabs>

       </div>
       <div style={{display: 'flex'}}>
         <Space direction="vertical" size={12}>
          <RangePicker
            value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
            onChange={(v,dateString)=> handleDateChange(v,dateString)}/>
          </Space>
          <Select
            defaultValue='all'
            style={{width: "20%",marginLeft: "2rem"}}
            onChange={handleTrnxTypeChange}
            // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
            showSearch
            options={trnxTypeOptions.map((c)=> ({value: c,label: c}))}
            placeholder="Select Category"
          />
       </div>
      <Table loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={statements} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalStatements} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}
